module.exports = __webpack_public_path__ + "img/industrial-detail.db8637f5.jpg";